import '../../style/';
import '../../icon/style/';
import './index.less';



/** WEBPACK FOOTER **
 ** ./components/badge/style/index.web.tsx
 **/